import { Button, Divider, Stack } from '@mui/material';
import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import MeetingNotes from './meetingNotes';

import ViewInterviewPlanner from '../../customer/report/reportActions/otherActions/interviewPlanner/viewInterviwePlanner';
import buttonStyle from '../../customer/reports/reportDocuments/attachments/requestInformationTab/styles/buttonStyle';

enum MeetingNotesTabs {
  INTERVIEW_QUESTIONS = 'INTERVIEW_QUESTIONS',
  INVESTIGATOR_NOTES = 'INVESTIGATOR_NOTES',
}

function MeetingNotesTab() {
  const tabsRef = useRef<HTMLDivElement>(null);
  const [openTab, setOpenTab] = useState<MeetingNotesTabs>(
    MeetingNotesTabs.INTERVIEW_QUESTIONS,
  );

  return (
    <Stack height='100%' position='relative'>
      <Stack
        direction={{
          md: 'row',
          xs: 'column',
        }}
        gap={1}
      >
        {Object.values(MeetingNotesTabs).map((meetingNotesTab) => {
          return (
            <Stack key={`btn-${meetingNotesTab}`} flexGrow={1}>
              <Button
                sx={{
                  ...buttonStyle,
                  color: openTab === meetingNotesTab ? '#00CECF' : 'gray',
                  background: 'transparent',
                  borderBottom:
                    openTab === meetingNotesTab ? '2px solid #00CECF' : 'none',
                }}
                onClick={() => {
                  setOpenTab(meetingNotesTab);
                  setTimeout(() => {
                    tabsRef.current?.scrollIntoView({ behavior: 'smooth' });
                  }, 100);
                }}
                fullWidth
              >
                {meetingNotesTab === MeetingNotesTabs.INTERVIEW_QUESTIONS && (
                  <FormattedMessage defaultMessage='Interview Questions' />
                )}
                {meetingNotesTab === MeetingNotesTabs.INVESTIGATOR_NOTES && (
                  <FormattedMessage defaultMessage='Notes' />
                )}
              </Button>
            </Stack>
          );
        })}
      </Stack>
      <Divider />
      <Stack
        sx={{
          height: 'calc(100% - 55px)',
          paddingTop: '16px',
          marginBottom: '10px',
        }}
        ref={tabsRef}
      >
        {openTab === MeetingNotesTabs.INTERVIEW_QUESTIONS && (
          <ViewInterviewPlanner />
        )}
        {openTab === MeetingNotesTabs.INVESTIGATOR_NOTES && <MeetingNotes />}
      </Stack>
    </Stack>
  );
}

export default MeetingNotesTab;
